import { Injectable } from '@angular/core';
import { ToursStateService } from './tours-state.service';

@Injectable({ providedIn: 'root' })
export class SmartFilterService {
  constructor(
    private stateService: ToursStateService,
  ) {

  }

  apply(list: any = {}): void {
    this.stateService.applySmartFilters(list.sort, list.filters);
  }
}
